<template>
  <div
    class="space-y-3"
    :class="{ 'border rounded-lg': !isSingleWarehouse }"
  >
    <div
      v-if="!isSingleWarehouse"
      class="flex items-center justify-between p-[16px] cursor-pointer group transition-colors duration-300"
      @click="handleToggleCollapse"
    >
      <h4 class="text-black text-lg font-semibold m-0">
        {{ title }}
      </h4>
      <button
        class="flex items-center justify-center gap-2 w-[26px] h-[26px] rounded-lg transition-all duration-300 ease-in-out group-hover:bg-[#e9e9e9]/40"
      >
        <span
          class="k-arrow-down-1 text-black text-lg transition-transform duration-300 ease-in-out"
          :class="{ 'rotate-180': !isCollapsed }"
        />
      </button>
    </div>
    <div
      class="transition-all duration-300 ease-in-out m-0"
      :class="{'hidden' : isCollapsed}"
    >
      <div
        ref="contentRef"
        :class="{ 'p-[16px]': !isSingleWarehouse }"
      >
        <slot
          name="default"
        />
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Packing Form Container to wrap the packing form
 * and add the collapse functionality
 */
export default {
  props: {
    title: {
      type: String,
      required: false,
      default: '',
    },
    isSingleWarehouse: {
      type: Boolean,
      default: false,
    },
    isDefaultCollapsed: {
      type: Boolean,
      default: false,
    },
    warehousesUsed: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isCollapsed: this.isDefaultCollapsed,
    }
  },
  watch: {
    isDefaultCollapsed(newVal) {
      this.isCollapsed = newVal
    },
  },
  methods: {
    /**
     * Handles the toggle collapse.
     */
    handleToggleCollapse() {
      this.isCollapsed = !this.isCollapsed
    },
  },
}
</script>
